<div class="copo-container">
	<div class="copo-section">
		<div class="copo-section-header">
			<span translate>fastlane.request.title</span>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column" *ngIf="form.getFormCustomerRequestName().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.header.customer-request-name</div>
					<div class="card-content-value">
						{{ form.getFormCustomerRequestName().value ?
						getRequestNameDescriptionText(form.getFormCustomerRequestName().value) :
						UNDERSCORE }}</div>
				</div>
			</div>
			<div class="copo-grid-row-column">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.soldto.name</div>
					<div class="card-content-value">
						{{ soldto ? soldto : UNDERSCORE }} </div>
				</div>
			</div>
			<div class="copo-grid-row-column"></div>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row-header-block-2">
			<div class="copo-grid-row-column" *ngIf="form.getFormShipTo().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.delivery.address</div>
					<div class="card-content-value">
						{{shipto}}</div>
				</div>
			</div>
			<div *ngIf="isCustomDestination" class="copo-grid-row-column box">
				<span class="card-content-label" translate>fastlane.wizard.custom.destination</span>
				<div class="custom-destination-row">
					<div class="custom-destination-column">
						<div class="card-content-info">
							<div class="card-content-label card-content-shipto" translate>fastlane.wizard.shipto.name</div>
							<div class="card-content-value">
								{{ form.getFormShipToCustom().value ?
									getDescriptionText(form.getFormShipToCustom().value) :
									UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="custom-destination-column">
						<div class="card-content-info">
							<div class="card-content-label card-content-shipto" translate>fastlane.wizard.custom.destination.contact.person</div>
							<div class="card-content-value">
								{{ form.getFormShipToPerson().value ?
									getDescriptionText(form.getFormShipToPerson().value) :
									UNDERSCORE }}
							</div>
						</div>
					</div>
				</div>
				<div class="custom-destination-row">
					<div class="custom-destination-column"></div>
					<div class="custom-destination-column">
						<div class="card-content-info">
							<div class="card-content-label" translate>fastlane.wizard.contact.phone.number</div>
							<div class="card-content-value card-content-value-custom">
								{{ form.getFormShipToContact().value ?
									getDescriptionText(form.getFormShipToContact().value) :
									UNDERSCORE }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="copo-section">
		<div class="copo-section-header">
			<span translate>fastlane.info.request.details</span>
		</div>
		<div class="copo-grid-row card-content-2">
			<div class="card-content-label">
				<mat-form-field class="card-content-comments"  appearance="outline" floatLabel="always">
					<mat-label>Description</mat-label>
					<textarea matInput [rows]="descriptionRowSize" readonly maxlength="255">{{description}}</textarea>
				</mat-form-field>
			</div>
			<div class="copo-attachment-block">
				<div *ngIf="hasRequestAttachments()" class="card-content-label" translate>
					claim.attachments</div>
				<div class="card-content-value" *ngFor="let attachment of getRequestAttachments();">
					<a class="attachment-link" [href]="attachment.localUrl | copoSafeUrl" target="_blank">{{attachment.fileName}}</a></div>
			</div>
		</div>
	</div>
	<div class="copo-section">
		<div class="copo-section-header">
			<span translate>fastlane.info.commercial.data</span>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column" *ngIf="form.getFormCurrency().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.currency</div>
					<div class="card-content-value">
						{{ currency ? currency : UNDERSCORE }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="copo-container fastlane-grey-block line-space">
	<div class="copo-section">
		<div class="copo-section-header">
			<div class="card-header-left">
				<div class="card-title-label">
					<span translate>fastlane.wizard.items.details.itemrequest</span>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="copo-container fastlane-product-block">
	<div class="copo-section">
		<form [formGroup]="productFormGroup" novalidate autocomplete="off">
			<div class="grid-column-one-full card-block">
				<div formArrayName="productSpecifications">
					<div class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index"
						[formGroupName]="i">
						<div
							[ngClass]="(isSheetSelected(i))?'card-header column-9 copo-dark-theme copo-dark-theme-padding':'card-header column-8 copo-dark-theme copo-dark-theme-padding'">
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									need4steel.wizard.stepper.product.itemnumber</div>
								<div class="card-header-label field-width">{{ i+1 | number: '3.' }}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.item_name</div>
								<div class="card-header-label field-width">
									{{getTextFieldValueByControl(i, 'name')}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.steel_grade</div>
								<div class="card-header-label field-width">
									{{getTextFieldValueByControl(i, 'steelgrade')}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.item_form</div>
								<div class="card-header-label field-width">
									{{getOrderTrackingForm(i, 'form')}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.order.thickness</div>
								<div class="card-header-label field-width">
									{{getValueByControlName(i, 'thickness')}}</div>
							</div>
							<div *ngIf="isSelectedAndNotFormBlanks(i)"
								class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									order.width</div>
								<div class="card-header-label field-width">
									{{getValueByControlName(i, 'width')}}
								</div>
							</div>
							<div *ngIf="isFormBlankSelected(i)"
								class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.blank_weight</div>
								<div class="card-header-label field-width">
									{{getValueByControlName(i, 'blankWeight')}}</div>
							</div>
							<div *ngIf="isSheetSelected(i)"
								class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									batch.length</div>
								<div class="card-header-label field-width">
									{{getValueByControlName(i, 'length')}}
								</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.global.quantity</div>
								<div class="card-header-label field-width">
									{{getValueByControlName(i, 'quantity')}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.global.unit</div>
								<div class="card-header-label field-width">
									{{getUnit(i)}}
								</div>
							</div>
						</div>
						<mat-expansion-panel class="product-section" [expanded]="true">
							<ng-template matExpansionPanelContent>
								<div class="copo-grid-row">
									<div class="card-content-left column-5">
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												order.coating</div>
											<div class="card-content-value">
												{{getTextFieldValueByControl(i, 'coating')}}</div>
										</div>
										<div *ngIf="isCoilOrSlittingCoilSelected(i)"
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.itemlist.product.coil_axis</div>
											<div class="card-content-value" translate>
												{{getCoilAxis(i)}}</div>
										</div>
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.itemlist.productcharacteristic.oilquantity</div>
											<div class="card-content-value">
												{{getTextFieldValueByControl(i, 'oiling')}}</div>
										</div>
										<div *ngIf="isCoilOrSlittingCoilSelected(i)"
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.itemlist.coil.inner.diameter</div>
											<div class="card-content-value">
												{{getValueByControlName(i, 'innerDiameter')}}</div>
										</div>
										<div *ngIf="isCoilOrSlittingCoilSelected(i)"
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.itemlist.coil.max_outer_diameter</div>
											<div class="card-content-value">
												{{getValueByControlName(i, 'maxOutsideDiameter')}}</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row card-content-total column-2">
									<div class="copo-content-product card-header-double-span copo-form-field label-padding">
										<div class="card-content-label" translate>
												fastlane.wizard.items.details.total.weight</div>
										<div class="card-content-value">
												{{getValueByControlName(i, 'totalWeight')}}</div>
									</div>
									<div *ngIf="isSheetSelected(i)" class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.wizard.items.details.sheet.weight</div>
											<div class="card-content-value">
												{{getValueByControlName(i, 'sheetWeightKg')}}</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="card-content-2">
										<div>
										<mat-form-field class="card-content-comments"  appearance="outline">
											<mat-label translate>fastlane.itemlist.item.additional.info</mat-label>
											<textarea [rows]="getAdditionalInfoRowSize(i)" matInput readonly
												maxlength="255" formControlName="additionalItemInfo">
											</textarea>
										</mat-form-field>
										</div>
										<div class="copo-attachment-block">
											<div *ngIf="hasAttachments(i)" class="card-content-label" translate>
												claim.attachments</div>
											<div class="card-content-value" *ngFor="let attachment of getAttachments(i);">
												<a class="attachment-link" [href]="attachment.localUrl | copoSafeUrl" target="_blank">{{attachment.fileName}}</a></div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="card-content-left column-6">
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.wizard.items.details.datetype</div>
											<div class="card-content-value">
												{{getRddType(i) | translate}}</div>
										</div>
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.wizard.items.details.datetype.rdd</div>
											<div class="card-content-value cal-icon-dispaly">
												{{getRdd(i)}}</div>
											<mat-icon svgIcon="calendar" class="cal-icon-color"></mat-icon>
										</div>
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												transport.mode</div>
											<div *ngIf="getTransportMode(i) === '-- None --'; else translatedTransport" class="card-content-value">
												{{getTransportMode(i)}}
											</div>
											<ng-template #translatedTransport><div class="card-content-value" translate>{{getTransportMode(i)}}</div></ng-template>
											
										</div>
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												eoffer.incoterms</div>
											<div class="card-content-value">
												{{getIncoterms(i)}}</div>
										</div>
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												order.packing</div>
											<div class="card-content-value">
												{{getTextFieldValueByControl(i, 'packing')}}</div>
										</div>
										<div
											class="copo-content-product card-header-double-span copo-form-field label-padding">
											<div class="card-content-label" translate>
												fastlane.wizard.product.transport.desired.arcelormittal.plant</div>
											<div class="card-content-value">
												{{getDesiredamlplant(i)}}</div>
										</div>
									</div>
								</div>
								<div class="copo-section-body copo-grid">
									<div class="copo-grid-row-header-block-2 copo-grid-row-custom-destination">
										<div class="copo-grid-row-column copo-delivery-address-padding" *ngIf="getTextFieldValueByControl(i, 'shipTo')">
											<div class="card-content-info">
												<div class="card-content-label " translate>fastlane.wizard.delivery.address</div>
												<div class="card-content-value">
													{{getSelectedShipByIndex(i)}}</div>
											</div>
										</div>
										<div *ngIf="getSelectedShipByIndex(i) === 'Custom destination'" class="copo-grid-row-column box">
											<span class="card-content-label card-content-shipto" translate>fastlane.wizard.custom.destination</span>
											<div class="custom-destination-row">
												<div class="custom-destination-column">
													<div class="card-content-info">
														<div class="card-content-label card-content-shipto" translate>fastlane.wizard.shipto.name</div>
														<div class="card-content-value">
															{{ getTextFieldValueByControl(i, 'shipToCustom') ?
																getDescriptionText(getTextFieldValueByControl(i, 'shipToCustom')) :
																UNDERSCORE }}
														</div>
													</div>
												</div>
												<div class="custom-destination-column">
													<div class="card-content-info">
														<div class="card-content-label card-content-shipto" translate>fastlane.wizard.custom.destination.contact.person</div>
														<div class="card-content-value">
															{{ getTextFieldValueByControl(i, 'shipToPerson') ?
																getDescriptionText(getTextFieldValueByControl(i, 'shipToPerson')) :
																UNDERSCORE }}
														</div>
													</div>
												</div>
											</div>
											<div class="custom-destination-row">
												<div class="custom-destination-column"></div>
												<div class="custom-destination-column">
													<div class="card-content-info">
														<div class="card-content-label" translate>fastlane.wizard.contact.phone.number</div>
														<div class="card-content-value card-content-value-custom">
															{{ getTextFieldValueByControl(i, 'shipToContact') ?
																getDescriptionText(getTextFieldValueByControl(i, 'shipToContact')) :
																UNDERSCORE }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</ng-template>
						</mat-expansion-panel>
						<mat-divider class="mat-divider"></mat-divider>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>